//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconList from './iconList.json';

export default {
  name: 'DpIconPicker',
  props: {
    value: { type: String, default: null },
  },
  data() {
    return {
      dropdownVisible: false,
    };
  },
  computed: {
    currentIcon() {
      return this.value;
    },
    publicIcons() {
      return Object.keys(IconList).map((category) => ({
        name: category,
        icons: IconList[category].map((name) => ({ name })),
      }));
    },
  },
  methods: {
    selectIcon(iconName) {
      this.$emit('input', iconName);
    },
  },
};
